<div class="container-fluid">
  <div class="row justify-content-center" style="padding-top: 150px;">
    <div class="col-11 text-center">
      <span style="font-size: 2rem;"
            i18n="welcome|Dashboard welcome message">Welcome to Rondeivu Admin Dashboard!</span>
      <br/>
      <em style="font-size:1.2rem; color: grey;" i18n="welcome-sub|Dashboard welcome sub message">This is where the
        magic happens!</em>
    </div>
    <div style="text-align: center; margin-top: 50px">
      <img src="../../../../../assets/images/wheel.png">
    </div>

    <div>
      <!-- <button mat-raised-button color="primary"
        [hasPermission]="util.Permission.CAN_ACCESS_AUDITS"
        [disabledOption1]="{ condition: isDisabled , message: 'test' }"
      >
        Test Button for disabling
      </button> -->


    </div>
  </div>
</div>
